import { documentHasBehaviour, documentHasSimModel, documentBehaviorHasErrors, } from "@buildwithflux/models";
import { getBehaviourWithoutComments } from "@buildwithflux/shared";
export function getDocumentSimulationData(document) {
    return {
        hasSimulationModel: documentHasSimModel(document),
        hasBehaviour: documentHasBehaviour(document),
        behaviour: document.behaviour ? getBehaviourWithoutComments(document.behaviour) : undefined,
        behaviourHasErrors: documentBehaviorHasErrors(document),
    };
}
//# sourceMappingURL=simulation.js.map